// 회사별 용어: 삼우에프앤지는 '작업자'를 '설치팀장'으로 부른다.
//   로그인 시 App.js가 localStorage에 companyName을 저장 → 어느 컴포넌트에서든 workerTerm()으로 호출.
//   삼우가 아니면 기본 '작업자' 유지(다른 회사 영향 없음).
export function workerTerm() {
  try {
    const c = localStorage.getItem("companyName") || "";
    return c.includes("삼우") ? "설치팀장" : "작업자";
  } catch (_) {
    return "작업자";
  }
}
